import React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import { EnhancedTableHead } from '../pages/conversations';
import useThemeQuery from '../../graphql/queries/toggle-theme';
import { getAtmosphereReaction, duration, capitalizeFirstLetter } from '../../utils/utils';

const useStyles = makeStyles(theme => ({
    text: {
        color: '#fff'
    },
    tableWrapper: {
        marginBottom: 50,
    }
}));

const EditConversation = ({ conversation }) => {
    const classes = useStyles();
    const { data } = useThemeQuery();
    const { formatMessage } = useIntl();


    const StyledTableRow = withStyles(theme => ({
        root: {
          backgroundColor: "rgb(11,36,62)",
            "&:first-child th": {
              borderTopLeftRadius: 15,
            },
            "&:first-child td+td+td+td+td+td": {
              borderTopRightRadius: 15
            },
            "&:last-child th": {
              borderBottomLeftRadius: 15
            },
            "&:last-child td+td+td+td+td+td": {
              borderBottomRightRadius: 15
            }
        }
      }))(TableRow);
      
    
      const StyledTableCell = withStyles(theme => ({
        root: {
            borderBottom: "none",
            paddingTop: 25, 
            paddingBottom: 25,
          },
        head: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        body: {
          fontSize: 16,
          color: 'rgb(255,255,255)', 
        }
      }))(TableCell);

    return (
        <div className={classes.tableWrapper}>
          <Table
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              theme= {data && data.theme}
              formatMessage={formatMessage}
            />
            <TableBody>
                <StyledTableRow
                  tabIndex={-1}
                  style={!(data && data.theme) ? {backgroundColor: '#fff', }: null}
                >
                  <StyledTableCell
                    component="th"
                    scope="row"
                    align="center"
                    width="5%"
                  >
                    <Typography style={{color: "#85919D"}}>
                      {"17min ago"}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell 
                    width="5%"
                    align="center"
                  >
                    <Box display="block">
                      <Typography 
                        style={!(data && data.theme) ? { color: '#000', fontWeight: 550 } : {fontWeight: 550}}
                      >
                        <Box display="block">
                          <Typography 
                            style={!(data && data.theme) ? { color: '#000', fontWeight: 550 } : {fontWeight: 550}}
                          >
                            {capitalizeFirstLetter(conversation.categorization.mainTopic)}
                          </Typography>
                        </Box>
                      </Typography>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell 
                    align="center"
                    width="5%"
                  >
                    <Box>
                        <img src={getAtmosphereReaction(conversation.atmosphere.sentiment)} alt="smiley" />
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell 
                    align="center"
                    width="5%"
                  >
                      <Typography 
                        display="block" 
                        style={!(data && data.theme) ? { color: '#364653', fontWeight: 500, marginTop: 10 } : {fontWeight: 500, marginTop: 10}}
                        >
                        {conversation.userId}
                      </Typography>
                  </StyledTableCell>
                  <StyledTableCell 
                    width="5%"
                    align="center"
                  >
                    <Typography 
                      alignItems="center" 
                      style={!(data && data.theme) ? { color: '#000', fontWeight: 550 } : {fontWeight: 550}}
                    >
                        {duration(conversation.duration)}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell 
                    width="8%"
                    align="center"
                  >
                    <Typography 
                      alignItems="center" 
                      style={!(data && data.theme) ? { color: '#364653', fontWeight: 500 } : {fontWeight: 500}}
                    >
                        {conversation.agentId}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell 
                    width="8%"
                    align="left"
                  >
                    <Box>
                      { conversation.categorization.topics.map(topic => {
                          return (
                            <Box key={topic.topicId}>
                              <Typography 
                                style={!(data && data.theme) ? { color: '#364653', fontWeight: 500 } : {fontWeight: 500}}
                              >
                                  {'- '+capitalizeFirstLetter(topic.name)}
                              </Typography>
                            </Box>
                          )
                        })
                      }
                    </Box>


                  </StyledTableCell>
                </StyledTableRow>
            </TableBody>
          </Table>
        </div>
    )
}

export default EditConversation;
